import { connect, mapProps } from '@formily/react';
import { CnNumberPicker as UiCnNumberPicker, } from '@/components/cn-number-picker';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnNumberPicker = connect(UiCnNumberPicker, mapProps(mapSize, mapStatus));
CnNumberPicker.displayName = 'CnNumberPicker';
